import axios from "axios";
import { useQuery } from "react-query";
import { sortBy } from "lodash";
import type { Timefactor } from "src/types/emission";
import { useCase } from "src/hooks/useCase";
import { useParams } from "react-router-dom";

export function useTimefactors() {
  const { caseId } = useParams<{ caseId: string }>();
  const { data: acase } = useCase(caseId || "");
  return useQuery<Timefactor[], Error>(["timefactors"], async () => {
    const response = await axios.get<Timefactor[]>(`/planning-api/genericifdmtimefactors/${acase?.runYear}`);

    return sortBy(response.data, "serialNumber");
  });
}
